<div class="backdrop"  [class.open]="open" (click)="close.emit()">
  <div class="modal"  onclick="event.stopPropagation()">
    <img class="close-icon" src="../../../assets/images/close.svg" (click)="close.emit()">
    <ng-content></ng-content>
  </div>
</div>
